
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"36","height":"36","rx":"8","fill":"#0E3DE2"}}),_c('g',{attrs:{"clip-path":"url(#clip0_1160_41338)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.9 18.8h.925a4.05 4.05 0 007.989.384.897.897 0 00.086-.384.9.9 0 111.8 0c0 .137.03.268.086.384a4.051 4.051 0 007.99-.384h.924a.9.9 0 100-1.8h-1.13a4.052 4.052 0 00-7.407-.532A2.687 2.687 0 0017.8 16.1c-.497 0-.963.134-1.363.368A4.052 4.052 0 009.03 17H7.9a.9.9 0 100 1.8zm4.95-2.7a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zm7.65 2.25a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1160_41338"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(7 8)","d":"M0 0h21.6v21.6H0z"}})])])])
          )
        }
      }
    